/**
 * コモンクラス
 * @constructor
 */
class Common {
  constructor() {

  }
  /**
   * コモン
   */
  init() {
    const self = this;
    $('.js-spMenu, .js-spMenuBtn').on('click', (e) => {
      this.toggleSpMenu(e.currentTarget);
    });
    $('.js-spMenu, .js-spMenuBtn').on('click', (e) => {
      this.spGnavToggle(e.currentTarget);
    });
  }


  toggleSpMenu(el) {
    ($(el).hasClass('is-open')) ? this.closeSpMenu(el) : this.openSpMenu(el);
  }
  openSpMenu(el) {
    $(el).addClass('is-open');
  }
  closeSpMenu(el) {
    $(el).removeClass('is-open');
  }
  spGnavToggle() {
    ($('.l-headerSp').hasClass('is-open')) ? this.spGnavClose() : this.spGnavOpen();
  }
  spGnavOpen() {
    $('.js-spGnav').addClass('is-open');
  }
  spGnavClose() {
    $('.js-spGnav').removeClass('is-open');
  }



}

export default Common;
